<template>
    <div class="standort-detail-wrapper angebot-detail-wrapper" ref="detailAngebot" v-if="selectedAngebot">
        <div class="standort-detail">
            <img :src="getImage('abt_'+field+'.svg')" class="angebot-detail-background-image" alt="">
            <div class="standort-detail-close" @click="closeAngebot">
                <img :src="getImage('x.svg')" alt="close">
            </div>
            <div class="standort-detail-left">
                <div class="angebot no-click">
                    <div class="angebot-title">
                        {{ selectedAngebot.attributes.Titel }}
                    </div>
                </div>
            </div>
            <div class="standort-detail-right angebot-detail-right">
                <div class="angebot-detail-right-text" v-html="selectedAngebot.attributes.Beschreibung"/>
                <div class="angebot-detail-right-images">
                    <template v-if="selectedAngebot.attributes.Bilder.data"
                              v-for="bild in selectedAngebot.attributes.Bilder.data">
                        <div class="standort-detail-image"
                             :style="'background-image: url('+this.config.imageBaseUrl+
                             bild.attributes.formats.medium.url+')'"
                        />
                    </template>
                </div>
            </div>
            <div class="standort-detail-images-mobile angebot-detail-images-mobile">
                <template v-if="selectedAngebot.attributes.Bilder.data"
                          v-for="bild in selectedAngebot.attributes.Bilder.data">
                    <div class="standort-detail-image-mobile-wrapper">
                        <div class="standort-detail-image-mobile"
                             :style="'background-image: url('+this.config.imageBaseUrl+
                             bild.attributes.formats.medium.url+')'"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div class="angebot-container">
        <template v-for="angebot in angebote" v-if="angebote">
            <div :class="'angebot '+getActiveClass(angebot)" @click="selectAngebot(angebot)">
                <div class="angebot-title">
                    {{ angebot.attributes.Titel }}
                </div>
            </div>
        </template>
        <template v-else>
            <i v-if="angebote===false">
                Leider konnten keine Angebote geladen werden. Bitte versuchen Sie es erneut.
            </i>
            <div class="loading-wrapper" v-else>
                <LoadingSpinner class="standort-spinner"/>
                <p>Angebote werden geladen...</p>
            </div>
        </template>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/elements/LoadingSpinner.vue";
import {nextTick} from "vue";

export default {
    data() {
        return {
            angebote: null,
            selectedAngebot: null,
            autoTimeoutAngebot: null,
        }
    },
    components: {
        LoadingSpinner
    },
    computed: {
        field() {
            return this.$store.state.clickedField;
        }
    },
    watch: {
        async selectedAngebot(ignored_val, ignored_oldVal) {
            if (this.selectedAngebot) {
                await nextTick();
                const container = this.$refs.detailAngebot;
                if (this.autoTimeoutAngebot !== null) {
                    clearTimeout(this.autoTimeoutAngebot);
                    this.autoTimeoutAngebot = null;
                }
                if (container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.add("open");
                container.style.height = "0px"
                setTimeout(() => {
                    container.style.height = height;
                }, 0);
                this.autoTimeoutMenu = setTimeout(() => {
                    container.style.height = 'auto';
                }, 500);
            }
        }
    },
    methods: {
        getActiveClass(angebot) {
            if (this.$store.state.activeOffers === null) {
                return '';
            }
            if (this.$store.state.activeOffers.includes(angebot.id)) {
                return 'active';
            }
        },
        loadAngebote() {
            if (this.field === null) {
                this.clearTimeout = setTimeout(() => {
                    this.standorte = null;
                }, 1000);
                return;
            }
            this.apiRequest('/offers?populate[]=Bilder&populate[]=Standorte&filters[Bereich][Titel][$eq]='
                + this.field)
                .then(cnt => {
                    this.angebote = cnt.data || null;
                })
                .catch(() => this.angebote = false);
        },
        closeAngebot() {
            this.$store.commit("setActiveStandorte", null);
            const container = this.$refs.detailAngebot;
            if (this.autoTimeoutAngebot !== null) {
                clearTimeout(this.autoTimeoutAngebot);
                this.autoTimeoutAngebot = null;
            }
            if (!container.classList.contains("open")) {
                return;
            }
            container.style.height = "auto";
            const height = container.clientHeight + "px";
            container.classList.remove("open");
            container.style.height = height;
            setTimeout(() => {
                container.style.height = '0px';
            }, 0);
            setTimeout(() => {
                this.selectedAngebot = null;
            }, 500);
        },
        selectAngebot(angebot) {
            if (this.selectedAngebot === angebot) {
                this.closeAngebot();
            } else {
                this.selectedAngebot = angebot;
                const activeStandorte = [];
                for (const standort of angebot.attributes.Standorte.data) {
                    activeStandorte.push(standort.id);
                }
                this.$store.commit("setActiveStandorte", activeStandorte);
            }
        }
    },
    mounted() {
        this.loadAngebote();
    }
}
</script>